import { SiteLayout } from "js/components/web/components/layouts/site-layout";
export const UserIndex = [
    { path: "/", component: SiteLayout }
];
